import { get, post, downloadBlob } from '../request.js';

/**
 * 查询生成记录
 */
export async function queryGenerateRecord(params) {
  return post('/api/gc_list/page', params);
}

/**
 * 批量删除生成记录
 */
export async function batchDeleteGenerateRecord(params) {
  return post('/api/gc/deleteBatch', params);
}

/**
 * 批量下载生成记录
 */
export async function batchDownloadGenerateRecord(params) {
  return downloadBlob('/api/gc/downloadBatchImagesZip', params);
}

/**
 * 查询素材列表
 */
export async function querySourceMaterialPage(params) {
  return post('/api/source_material/page', params)
}

/**
 * 删除素材
 */
export async function deletesSourceMaterial(id) {
  return get(`/api/source_material/delete/${id}`);
}

/**
 * 删除商品图
 */
export async function deletesProductImage(id) {
  return get(`/api/gc_list/delete/${id}`);
}
